var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconScreenmodeSystem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23,4v5h-5v-2h1.46c-1.62-2.41-4.35-4-7.46-4C7.38,3,3.56,6.51,3.06,11H1.05C1.56,5.4,6.27,1,12,1c3.72,0,7.01,1.87,9,4.71v-1.71h2ZM12,21c-3.11,0-5.85-1.59-7.46-4h1.46v-2H1v5H3v-1.71c1.99,2.84,5.28,4.71,9,4.71,5.73,0,10.44-4.4,10.95-10h-2.01c-.5,4.49-4.32,8-8.94,8Zm-4-8.26v-1.48l-1.7-1.4,1-1.73,2.06,.77,1.28-.74,.36-2.17h2l.36,2.17,1.28,.74,2.06-.77,1,1.73-1.7,1.4v1.48l1.7,1.4-1,1.73-2.06-.77-1.28,.74-.36,2.17h-2l-.36-2.17-1.28-.74-2.06,.77-1-1.73,1.7-1.4Zm2-.74c0,1.1,.9,2,2,2s2-.9,2-2-.9-2-2-2-2,.9-2,2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScreenmodeSystem);
export default __webpack_public_path__ + "static/1782902422/media/icon-screenmode-system.fb999ecb1e0df9dcaebbe6e15b1596ac.svg";
export { ForwardRef as ReactComponent };